export const get_us_states = () => {
  return [
    { value: 'alabama', label: 'Alabama' },
    { value: 'alaska', label: 'Alaska' },
    { value: 'arizona', label: 'Arizona' },
    { value: 'arkansas', label: 'Arkansas' },
    { value: 'california', label: 'California' },
    { value: 'colorado', label: 'Colorado' },
    { value: 'connecticut', label: 'Connecticut' },
    { value: 'delaware', label: 'Delaware' },
    { value: 'florida', label: 'Florida' },
    { value: 'georgia', label: 'Georgia' },
    { value: 'hawaii', label: 'Hawaii' },
    { value: 'idaho', label: 'Idaho' },
    { value: 'illinois', label: 'Illinois' },
    { value: 'indiana', label: 'Indiana' },
    { value: 'iowa', label: 'Iowa' },
    { value: 'kansas', label: 'Kansas' },
    { value: 'kentucky', label: 'Kentucky' },
    { value: 'louisiana', label: 'Louisiana' },
    { value: 'maine', label: 'Maine' },
    { value: 'maryland', label: 'Maryland' },
    { value: 'massachusetts', label: 'Massachusetts' },
    { value: 'michigan', label: 'Michigan' },
    { value: 'minnesota', label: 'Minnesota' },
    { value: 'mississippi', label: 'Mississippi' },
    { value: 'missouri', label: 'Missouri' },
    { value: 'montana', label: 'Montana' },
    { value: 'nebraska', label: 'Nebraska' },
    { value: 'nevada', label: 'Nevada' },
    { value: 'new_hampshire', label: 'New Hampshire' },
    { value: 'new_jersey', label: 'New Jersey' },
    { value: 'new_mexico', label: 'New Mexico' },
    { value: 'new_york', label: 'New York' },
    { value: 'north_carolina', label: 'North Carolina' },
    { value: 'north_dakota', label: 'North Dakota' },
    { value: 'ohio', label: 'Ohio' },
    { value: 'oklahoma', label: 'Oklahoma' },
    { value: 'oregon', label: 'Oregon' },
    { value: 'pennsylvania', label: 'Pennsylvania' },
    { value: 'rhode_island', label: 'Rhode Island' },
    { value: 'south_carolina', label: 'South Carolina' },
    { value: 'south_dakota', label: 'South Dakota' },
    { value: 'tennessee', label: 'Tennessee' },
    { value: 'texas', label: 'Texas' },
    { value: 'utah', label: 'Utah' },
    { value: 'vermont', label: 'Vermont' },
    { value: 'virginia', label: 'Virginia' },
    { value: 'washington', label: 'Washington' },
    { value: 'west_virginia', label: 'West Virginia' },
    { value: 'wisconsin', label: 'Wisconsin' },
    { value: 'wyoming', label: 'Wyoming' },
    { value: 'district_of_columbia', label: 'District of Columbia' }
  ];
};

// State to timezone mapping (using primary timezone for states with multiple)
export const state_to_timezone = {
  'alabama': 'America/Chicago',
  'alaska': 'America/Anchorage',
  'arizona': 'America/Phoenix',
  'arkansas': 'America/Chicago',
  'california': 'America/Los_Angeles',
  'colorado': 'America/Denver',
  'connecticut': 'America/New_York',
  'delaware': 'America/New_York',
  'florida': 'America/New_York',
  'georgia': 'America/New_York',
  'hawaii': 'Pacific/Honolulu',
  'idaho': 'America/Boise',
  'illinois': 'America/Chicago',
  'indiana': 'America/Indiana/Indianapolis',
  'iowa': 'America/Chicago',
  'kansas': 'America/Chicago',
  'kentucky': 'America/New_York',
  'louisiana': 'America/Chicago',
  'maine': 'America/New_York',
  'maryland': 'America/New_York',
  'massachusetts': 'America/New_York',
  'michigan': 'America/Detroit',
  'minnesota': 'America/Chicago',
  'mississippi': 'America/Chicago',
  'missouri': 'America/Chicago',
  'montana': 'America/Denver',
  'nebraska': 'America/Chicago',
  'nevada': 'America/Los_Angeles',
  'new_hampshire': 'America/New_York',
  'new_jersey': 'America/New_York',
  'new_mexico': 'America/Denver',
  'new_york': 'America/New_York',
  'north_carolina': 'America/New_York',
  'north_dakota': 'America/Chicago',
  'ohio': 'America/New_York',
  'oklahoma': 'America/Chicago',
  'oregon': 'America/Los_Angeles',
  'pennsylvania': 'America/New_York',
  'rhode_island': 'America/New_York',
  'south_carolina': 'America/New_York',
  'south_dakota': 'America/Chicago',
  'tennessee': 'America/Chicago',
  'texas': 'America/Chicago',
  'utah': 'America/Denver',
  'vermont': 'America/New_York',
  'virginia': 'America/New_York',
  'washington': 'America/Los_Angeles',
  'west_virginia': 'America/New_York',
  'wisconsin': 'America/Chicago',
  'wyoming': 'America/Denver',
  'district_of_columbia': 'America/New_York'
};

// Get timezone for a state
export const get_timezone_for_state = (stateValue) => {
  return state_to_timezone[stateValue] || '';
};

// Get display-friendly timezone name
export const get_timezone_display = (timezone) => {
  const timezoneLabels = {
    'America/New_York': 'Eastern Time (ET)',
    'America/Chicago': 'Central Time (CT)',
    'America/Denver': 'Mountain Time (MT)',
    'America/Los_Angeles': 'Pacific Time (PT)',
    'America/Anchorage': 'Alaska Time (AKT)',
    'Pacific/Honolulu': 'Hawaii Time (HT)',
    'America/Phoenix': 'Mountain Time - Arizona (MT)',
    'America/Boise': 'Mountain Time (MT)',
    'America/Detroit': 'Eastern Time (ET)',
    'America/Indiana/Indianapolis': 'Eastern Time (ET)'
  };
  return timezoneLabels[timezone] || timezone;
};
